<template>
  <v-container fluid full-height grid-list-md>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <vue-title :title="pageTitle + ' | JUDO POS'"></vue-title>
    <v-layout row>
      <v-flex xs12 v-if="isBreadcrumbs">
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs12 v-if="sale.id">
        <div class="text-xs-right">
          <v-btn outline color="primary" @click="goBack">
            Go Back
            <v-icon right>arrow_back</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap transition="slide-x-transition">
        <v-flex xs6 mt-1>
          <v-card>
            <v-layout row wrap>
              <v-flex xs7 ml-4>
                <v-autocomplete
                  v-model="currencyId"
                  :items="currencyList"
                  color="blue-grey lighten-2"
                  label="Choose Currency..."
                  item-text="code"
                  menu-props="auto"
                  prepend-icon="monetization_on"
                  @change="onSearch(), init(), changeCurrencyCode()"
                  item-value="id"
                  :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                  :rules="rules.currencyRules"
                ></v-autocomplete>
              </v-flex>
              <!-- Barcode input -->
              <v-flex xs7 ml-4>
                <v-text-field
                  name="scanBarcode"
                  label="Scan barcode....."
                  v-model="scanBarcode"
                  type="text"
                  v-on:keyup.enter="trigger(scanBarcode)"
                  autofocus
                  prepend-icon="filter_center_focus"
                  :readonly="status == 'CONFIRM' || status == 'CANCEL' || !currencyId"
                ></v-text-field>
              </v-flex>
              <!-- Barcode input -->

              <v-flex xs3 mt-1>
                <v-btn
                  color="primary"
                  outline
                  @click="isShowStock=!isShowStock; "
                  :disabled="status == 'CONFIRM' || status == 'CANCEL' || !currencyId"
                >
                  <v-icon left>remove_red_eye</v-icon>
                  <span v-if="!isShowStock">Show Stock</span>
                  <span v-else>Hide Stock</span>
                </v-btn>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <!-- Barcode input -->
              <v-flex xs7 ml-4>
                <v-text-field
                  name="enteredProductCode"
                  label="Enter product code"
                  v-model="enteredProductCode"
                  type="text"
                  v-on:keyup.enter="getProductByCode(enteredProductCode)"
                  autofocus
                  prepend-icon="assignment_returned"
                  :readonly="status == 'CONFIRM' || status == 'CANCEL' || !currencyId"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <!-- Product Group Code input -->
              <v-flex xs7 ml-4>
                <v-text-field
                  name="enteredProductGroupCode"
                  label="Enter product group code"
                  v-model="enteredProductGroupCode"
                  type="text"
                  v-on:keyup.enter="getProductGroupByCode(enteredProductGroupCode), isShowStock=true, categoryName=''"
                  prepend-icon="assignment_returned"
                  :readonly="status == 'CONFIRM' || status == 'CANCEL' || !currencyId"
                ></v-text-field>
              </v-flex>

              <v-flex xs4 ml-2 mt-1>
                <v-switch
                  :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                  v-model="isFOC"
                  inset
                  :label="isFOC == true ? 'FOC' : 'Sale'"
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-divider></v-divider>
            <!-- Sale Items cart -->
            <v-flex xs16 ma-3 pa-2>
              <v-card>
                <v-card-title primary-title>
                  <div>
                    <div class="title">Sale Items</div>
                  </div>
                </v-card-title>
                <v-card-text class="cart">
                  <v-layout row>
                    <v-flex xs12 sm2>Code</v-flex>
                    <v-flex xs12 sm5 class="text-xs-center">Stock Name</v-flex>
                    <v-flex xs12 sm2 class="text-xs-center">Qty</v-flex>
                    <v-flex xs12 sm3 class="text-xs-center">Price</v-flex>
                    <v-flex xs12 sm3 class="text-xs-center">Amount</v-flex>
                    <v-flex xs12 sm1></v-flex>
                  </v-layout>
                  <v-divider></v-divider>

                  <v-flex v-if="getSaleItems.length == 0" text-xs-center ma-3>No items.</v-flex>
                  <v-flex
                    style="max-height:70vh;overflow-y:auto;overflow-x:hidden;"
                    v-for="(item, index) in sale.saleItems"
                    :key="index"
                  >
                    <v-layout row class="white" v-if="item.isFOC !== true">
                      <v-flex xs12 sm2 pt-4>{{item.productCode}}</v-flex>
                      <v-flex xs12 sm5 pt-4>{{item.productName}}</v-flex>
                      <v-flex xs12 sm2 class="text-xs-center">
                        <v-text-field
                          v-model="item.qty"
                          min="0"
                          type="number"
                          :rules="rules.qtyRules"
                          oninput="this.value = Math.abs(this.value)"
                          v-on:change="changeUnitPrice(item)"
                          :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 pt-4 class="text-xs-center">
                        {{item.unitPrice | decFormat}}
                        <span v-if="isShowCurrency">{{ currency }}</span>
                      </v-flex>
                      <v-flex xs12 sm3 pt-4 class="text-xs-center">
                        {{item.qty * item.unitPrice | decFormat}}
                        <span
                          v-if="isShowCurrency"
                        >{{ currency }}</span>
                      </v-flex>
                      <v-flex xs12 sm1 pt-2>
                        <v-btn
                          icon
                          @click="removeItem(index, item.id)"
                          :disabled="status == 'CONFIRM' || status == 'CANCEL'"
                        >
                          <v-icon>cancel</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- FOC Items cart -->
            <v-flex xs16 ma-3 pa-2>
              <v-card>
                <v-card-title primary-title>
                  <div>
                    <div class="title">FOC Items</div>
                  </div>
                </v-card-title>
                <v-card-text class="cart">
                  <v-layout row>
                    <v-flex xs12 sm2>Code</v-flex>
                    <v-flex xs12 sm5 class="text-xs-center">Stock Name</v-flex>
                    <v-flex xs12 sm2 class="text-xs-center">Qty</v-flex>
                    <v-flex xs12 sm1></v-flex>
                  </v-layout>
                  <v-divider></v-divider>

                  <v-flex v-if="getFOCItems.length == 0" text-xs-center ma-3>No items.</v-flex>
                  <v-flex
                    style="max-height:70vh;overflow-y:auto;overflow-x:hidden;"
                    v-for="(item, index) in sale.saleItems"
                    :key="index"
                  >
                    <v-layout row class="white" v-if="item.isFOC === true">
                      <v-flex xs12 sm2 pt-4>{{item.productCode}}</v-flex>
                      <v-flex xs12 sm5 pt-4>{{item.productName}}</v-flex>
                      <v-flex xs12 sm2>
                        <v-text-field
                          :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                          v-model="item.qty"
                          min="0"
                          type="number"
                          :rules="rules.qtyRules"
                          oninput="this.value = Math.abs(this.value)"
                          v-on:change="changeUnitPrice(item)"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm1 pt-2>
                        <v-btn
                          icon
                          @click="removeItem(index, item.id)"
                          :disabled="status == 'CONFIRM' || status == 'CANCEL'"
                        >
                          <v-icon>cancel</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- cart -->
          </v-card>
        </v-flex>
        <v-flex xs6>
          <!-- Stock -->
          <v-slide-y-transition>
            <v-card>
              <v-layout>
                <!-- <v-flex>
                  <v-flex>
                    <v-menu
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="status == 'CONFIRM' || status == 'CANCEL'"
                    >
                      <v-text-field
                        label="IssueDate"
                        slot="activator"
                        type="text"
                        prepend-icon="event"
                        v-model="issueDate"
                        readonly
                        :rules="rules.issueDateRules"
                      ></v-text-field>
                      <v-date-picker v-model="issueDate" :rules="rules.issueDateRules"></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-flex>-->
                <v-flex v-if="sale.id">
                  <v-flex ml-3 mr-3 mt-2>
                    <v-select
                      :items="statusList"
                      label="Status"
                      item-text="label"
                      item-value="value"
                      v-model="sale.status"
                      :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                    ></v-select>
                  </v-flex>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-flex v-show="isShowStock">
                <v-layout row>
                  <v-flex xs8 pa-3 mt-1 class="text-xs-right">
                    <h3>
                      Total Amount: {{netAmount | decFormat}}
                      <span
                        v-if="isShowCurrency"
                      >{{ currency }}</span>
                    </h3>
                  </v-flex>
                  <v-flex xs4 ml-1>
                    <v-btn
                      color="success"
                      large
                      @click="showPaymentMethods()"
                      :disabled="sale.saleItems.length === 0 || !valid"
                    >Make Payment</v-btn>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-expansion-panel v-model="categoryPanel" mb-3>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div>
                        <strong>Category : {{categoryName}}</strong>
                      </div>
                    </template>
                    <v-layout row wrap pa-2>
                      <v-flex xs4 v-for="(category, index) in categoryList" :key="index">
                        <v-btn
                          block
                          color="primary"
                          @click="onSearch(category);categoryPanel=false"
                        >{{category.name}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-flex v-if="categoryName == ''">
                  <h3>Product Group Name : {{ productGroupName }}</h3>
                </v-flex>
                <v-flex mt-3 style="max-height:100vh;overflow-y:auto;overflow-x:hidden;">
                  <v-data-iterator
                    :items="productList"
                    :total-items="totalRows"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="pagination"
                    :loading="showListLoading"
                    content-tag="v-layout"
                    row
                    wrap
                  >
                    <v-flex slot="item" slot-scope="props" xs12 sm6 md4 lg3>
                      <v-hover>
                        <v-card
                          slot-scope="{ hover }"
                          :class="`elevation-${hover ? 4 : 0}`"
                          class="mx-auto"
                          :title="props.item.name"
                          @click="showProductUnitDialog(props.item)"
                        >
                          <v-img
                            v-if="props.item.imageUrl"
                            :aspect-ratio="16/9"
                            :src="props.item.imageUrl"
                          ></v-img>
                          <v-card-title>
                            <div class="grey--text">{{props.item.code}}</div>
                            <div class="stock-name">{{props.item.name}}</div>
                          </v-card-title>
                        </v-card>
                      </v-hover>
                    </v-flex>
                  </v-data-iterator>
                </v-flex>
              </v-flex>
            </v-card>
          </v-slide-y-transition>

          <!-- Stock -->
          <v-slide-y-reverse-transition>
            <v-flex v-show="!isShowStock">
              <v-layout row>
                <!-- Counter Detail -->
                <v-flex xs6 pb-2>
                  <v-flex xs12>
                    <strong>Shop Name:</strong>
                    {{sale.shopName}}
                  </v-flex>
                  <v-flex xs12>
                    <strong>Counter Name:</strong>
                    {{sale.counterName}}
                  </v-flex>
                </v-flex>
                <!-- Counter Detail -->

                <!-- Retrieve / Park Sale -->
                <v-flex xs6 mt-2>
                  <v-btn
                    @click="showParkSales = !showParkSales"
                    :disabled="status == 'CONFIRM' || status == 'CANCEL'"
                  >
                    <i class="material-icons">reply</i>Retrieve Sale
                  </v-btn>
                  <v-btn
                    @click="showNote = !showNote"
                    :disabled="sale.saleItems.length === 0 || status == 'CONFIRM' || status == 'CANCEL'"
                  >
                    <i class="material-icons">settings_backup_restore</i>Park Sale
                  </v-btn>
                </v-flex>
                <!-- Retrieve / Park Sale -->
              </v-layout>
              <!--  -->
              <!-- receipt Section -->
              <v-divider></v-divider>
              <v-layout row>
                <v-flex xs8>Total Amount:</v-flex>
                <v-flex xs4 class="text-xs-right">
                  {{sale.totalAmount | decFormat}}
                  <span v-if="isShowCurrency">{{ currency }}</span>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs8>Tax({{sale.taxType}})({{sale.taxPercentage}}%):</v-flex>
                <v-flex xs4 class="text-xs-right">
                  {{sale.taxAmount | decFormat}}
                  <span v-if="isShowCurrency">{{ currency }}</span>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout row>
                <v-flex xs8>
                  <h3>Net Amount:</h3>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <h3>
                    {{netAmount | decFormat}}
                    <span v-if="isShowCurrency">{{ currency }}</span>
                  </h3>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout row>
                <v-flex xs12 text-xs-right>
                  <v-btn
                    color="success"
                    large
                    @click="showPaymentMethods()"
                    :disabled="sale.saleItems.length === 0"
                  >Make Payment</v-btn>
                </v-flex>
              </v-layout>
              <!-- receipt section -->
            </v-flex>
          </v-slide-y-reverse-transition>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- Invoice print hidden area -->
    <div id="invoicePrint" v-show="false">
      <div style="font-size: 11px;font-family: arial,sans-serif;">
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">{{sale.shopName}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">{{sale.address}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Tel: {{sale.phoneNo}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Invoice #: {{sale.saleNo}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px" id="date"></p>
        </div>
        <div style="float:left;padding-left:11px">
          <p style="font-size:11px;margin:0px" id="counter">Counter: {{sale.counterName}}</p>
          <p style="font-size:11px;margin:0px" id="casher">Casher: {{sale.username}}</p>
          <p
            v-if="this.salePerson"
            style="font-size:11px;margin:0px"
            id="casher"
          >Sale: {{this.salePerson}}</p>
          <p style="font-size:11px;margin:0px" id="customer">Customer: {{sale.customerName}}</p>
        </div>
        <div style="float:right;padding-right:11px">
          <p style="font-size:11px;margin:0px" id="casher">Currency: {{currency}}</p>
        </div>
        
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left;width:50%"></th>
                <th style="text-align:center;width:10%">Unit</th>
                <th style="text-align:center;width:10%">Qty</th>
                <th style="text-align:right;width:10%">Price</th>
                <th style="text-align:right;width:20%">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in getSaleItems" :key="index">
                <td
                  v-if="item.productColor"
                  style="text-align:left;width:50%"
                >{{item.productName}} {{'(' + item.productColor + ')'}}</td>
                <td v-else style="text-align:left;width:50%">{{item.productName}}</td>
                <td style="text-align:center;width:10%">{{item.factorUnitName}}</td>
                <td style="text-align:center;width:10%">{{item.qty}}</td>
                <td style="text-align:right;width:10%">{{item.unitPrice | decFormat}}</td>
                <td style="text-align:right;width:20%">{{item.qty * item.unitPrice | decFormat}}</td>
              </tr>
            </tbody>
          </table>
          <div style="height:10px"></div>
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
          >
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Total Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.totalAmount | decFormat}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Tax ({{sale.taxType}})</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.taxAmount | decFormat}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Discount Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
                v-if="this.sale.discountAmount > 0"
              >{{this.sale.discountAmount | decFormat}}</td>
              <td style="text-align:right;font-weight:bold;font-size:11px" v-else>0</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Net Amount</td>
              <td style="text-align:right;font-weight:bold;font-size:11px">{{netAmount | decFormat}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Received</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.receivedAmount | decFormat}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Pay Change</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.payChange | decFormat}}</td>
            </tr>
          </table>
        </div>
        <!-- FOC Items -->
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px" v-if="getFOCItems.length > 0">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left;width:50%">FOC Items</th>
                <th style="text-align:center;width:10%">Unit</th>
                <th style="text-align:center;width:10%">Qty</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in getFOCItems" :key="index">
                <td style="text-align:left;width:50%">{{item.productName}}</td>
                <td style="text-align:center;width:10%">{{item.factorUnitName}}</td>
                <td style="text-align:center;width:10%">{{item.qty}}</td>
              </tr>
            </tbody>
          </table>
          <div style="height:10px"></div>
        </div>
        <div style="height:5px;"></div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Thank You! Please Come Again.</p>
        </div>
      </div>
    </div>
    <!-- final message dialog -->
    <v-dialog v-model="messageDialogBox" max-width="500px" @keydown.enter="messageDialogBox=false">
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Park sales dialog-->
    <v-dialog v-model="showParkSales" persistent max-width="500">
      <v-card>
        <v-card-title>
          <h3>Park Sales</h3>
        </v-card-title>
        <v-card-text>
          <v-layout row v-for="(item, index) in parkItems" :key="index">
            <v-flex xs12 sm3 class="grey--text">Note: {{item.note}}</v-flex>
            <v-flex xs12 sm3>{{item.saleItems[0].barcode}}</v-flex>
            <v-flex xs12 sm3>{{item.saleItems[0].productName}}</v-flex>
            <v-flex xs12 sm3>{{item.saleItems[0].factorUnitName}}</v-flex>
            <v-flex xs12 sm3>
              <v-btn color="primary" @click="retrieveSale(index)">
                <v-icon>reply</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row v-show="parkItems.length === 0">
            <v-flex>There is no park sale.</v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="showParkSales = !showParkSales">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Show note dialog-->
    <v-dialog v-model="showNote" persistent max-width="290">
      <v-form ref="noteDialog" @submit.prevent="parkSale">
        <v-card>
          <v-card-text>
            <v-text-field
              label="Note"
              required
              v-model="sale.note"
              :rules="[v => !!v || 'Note is required']"
            ></v-text-field>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" flat @click.native="closeModal">
                Cancel
                <v-icon right>clear</v-icon>
              </v-btn>
              <v-btn color="blue darken-1" flat type="submit">
                Save
                <v-icon right>save</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <!--Payment dialog-->
    <v-dialog v-model="showPaymentMethodDialog" max-width="800" @keydown.enter="confirmPayment()">
      <v-form ref="paymentModalForm" lazy-validation @submit.prevent="confirmPayment">
        <v-card>
          <v-card-text max-height="auto">
            <v-layout row>
              <v-flex xs6>
                <v-flex ml-3 mr-3 mt-2>
                  <h2>Payment Method</h2>
                  <v-select :items="payTypes" label="payType" v-model="payType" @change="calculateAmount" solo></v-select>
                </v-flex>
              </v-flex>
              <v-flex xs6>
                <v-flex ml-3 mr-3 mt-2>
                  <h2>Tax On</h2>
                  <v-checkbox
                    v-model="isTaxOn"
                    @change="calculateAmount"
                    :disabled="status == 'CONFIRM' || status == 'CANCEL'"
                  ></v-checkbox>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex>
                <v-text-field
                  placeholder="Choose Customer"
                  v-model="sale.customerName"
                  @click.stop="showCustomers()"
                  :rules="getCustomerRule()"
                  clearable
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex xs12>
                <v-flex ma-3>
                  <h2>
                    Total Amount :
                    <span style="color:green">
                      {{sale.totalAmount | decFormat}}
                      <span v-if="isShowCurrency">{{ currency }}</span>
                    </span>
                  </h2>
                </v-flex>
              </v-flex>
              <v-flex xs12 v-if="isTaxOn">
                <v-flex ma-3>
                  <h2>
                    Tax({{sale.taxType}}):
                    <span style="color:red">
                      {{ sale.taxAmount | decFormat}}
                      <span v-if="isShowCurrency">{{ currency }}</span>
                    </span>
                  </h2>
                </v-flex>
              </v-flex>
              <v-flex xs12>
                <v-flex ml-3 mr-3 mt-2>
                  <h2>
                    Discount Amount:
                    <v-text-field
                      v-model="sale.discountAmount"
                      label="Amount"
                      min="0"
                      type="number"
                      outline
                      :prefix="currency"
                      autofocus
                      :rules="rules.discountAmountRules"
                      :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                    >
                      <span v-if="isShowCurrency">{{ currency }}</span>
                    </v-text-field>
                  </h2>
                </v-flex>
              </v-flex>
              <v-flex xs12 v-if="discountError">
                &nbsp;&nbsp;
                <span class="red--text">&nbsp;&nbsp;{{discountError}}</span>
              </v-flex>
              <v-flex xs12 ma-3>
                <h1>
                  Net Amount:
                  <span style="color:green">
                    {{ netAmount | decFormat}}
                    <span v-if="isShowCurrency">{{ currency }}</span>
                  </span>
                </h1>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row>
              <v-flex ma-3>
                <h2>Received :</h2>
                <v-text-field
                  v-model="receivedAmount"
                  min="0"
                  type="number"
                  label="Amount"
                  outline
                  prefix="MMK"
                  v-if="showPaymentMethodDialog && !confirmBox"
                  autofocus
                  @focus="$event.target.select()"
                  :rules="rules.receivedAmountRules(payType, netAmount)"
                  :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 v-if="sale.id">
                <v-flex ml-3 mr-3 mt-2>
                  <h2>Sale Person</h2>
                  <v-text-field
                    v-model="sale.salePerson"
                    type="text"
                    label="Saleperson"
                    :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                  ></v-text-field>
                </v-flex>
              </v-flex>
              <v-flex xs12 v-else>
                <v-flex ml-3 mr-3 mt-2>
                  <h2>Sale Person</h2>
                  <v-select
                    :items="salePersonList"
                    item-text="username"
                    menu-props="auto"
                    item-value="id"
                    v-model="sale.salePersonId"
                    v-on:change="getSalePersonName(sale.salePersonId)"
                  ></v-select>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 v-if="sale.id">
                <v-flex ml-3 mr-3 mt-2>
                  <h2>Card No</h2>
                  <v-text-field
                    v-model="sale.cardNo"
                    type="text"
                    label="Card"
                    :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                  ></v-text-field>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex ma-3>
                <h2>Remark :</h2>
                <v-text-field
                  v-model="sale.remark"
                  v-if="showPaymentMethodDialog && !confirmBox"
                  autofocus
                  @focus="$event.target.select()"
                  :rules="rules.remarkRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row v-if="payType == 'CASH'">
              <v-flex ma-3>
                <h1>
                  Pay Change :
                  <span style="color:red">
                    {{ payChangeAmount | decFormat}}
                    <span v-if="isShowCurrency">{{ currency }}</span>
                  </span>
                </h1>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex text-xs-center mt-3>
                <v-btn
                  color="success"
                  large
                  outline
                  @click="confirmPayment"
                  :disabled="status == 'CONFIRM' || status == 'CANCEL'"
                >Confirm Payment</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" flat @click="onClose">
              Close
              <v-icon right>clear</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- ProductUnit dialog -->
    <v-dialog v-model="openProductUnitDialog" max-width="700">
      <v-card>
        <v-card-title>
          <h2>Choose Stock</h2>
        </v-card-title>
        <v-card-title>
          <h3>Product Code: {{ productCode }}</h3>
        </v-card-title>
        <v-card-title>
          <h3>Product Name: {{ productName }}</h3>
        </v-card-title>
        <v-card-title>
          <h3>Product Color: {{ productColor }}</h3>
        </v-card-title>
        <v-layout row wrap pa-2>
          <v-flex v-for="(productUnit, index) in productUnitList" :key="index" xs12 sm6 md4 lg3>
            <v-hover>
              <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 4 : 0}`" class="mx-auto">
                <v-card-title>
                  <p class="grey--text">{{productUnit.barcode}}</p>
                  <p class="grey--text">{{productUnit.product.name}}</p>
                  <p>{{productUnit.sellingPrice | decFormat}} {{currency}}</p>
                  <p>Unit: {{productUnit.factorUnitName}}</p>
                  <p>Available Qty: {{productUnit.qty}}</p>
                </v-card-title>
                <v-card-actions>
                  <v-btn
                    :disabled="productUnit.qty == 0 || (productUnit.reorderQty > 0 && (productUnit.qty * productUnit.factor) <= productUnit.reorderQty)"
                    :ref="`bc-${productUnit.barcode}`"
                    outline
                    color="orange"
                    @click="addToCart(productUnit)"
                  >Add To Card</v-btn>
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex v-if="!productUnitList.length">
            <h5 style="color:red">*There is no productUnit.</h5>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="primary"
            @click.native="openProductUnitDialog = !openProductUnitDialog"
          >Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Customer list dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Customer Name"
                type="text"
                v-model="customerQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="email"
                label="Customer Email"
                type="text"
                v-model="customerQueryParams.email"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="creditLevelList"
                v-model="customerQueryParams.creditLevelId"
                label="Choose Credit Level"
                item-text="name"
                item-value="id"
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="customerOnSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="customerList"
                class="elevation-1"
                :loading="showCustomerListLoading"
                :total-items="customerTotalRows"
                :rows-per-page-items="customerRowsPerPageItems"
                :pagination.sync="customerPagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td @click="setCustomer(props.item)">
                    <a>{{ props.item.name }}</a>
                  </td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ props.item.phoneNo }}</td>
                  <td>{{ props.item.creditLevel.name}}</td>
                  <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
                  <td>{{ props.item.updatedBy }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- confrim dialog -->
    <v-dialog
      v-model="confirmBox"
      max-width="500px"
      @keydown.enter="proceedPayment()"
      @keydown.esc="open = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>Are you sure to make this payment transaction?</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="confirmBox=false">Cancel</v-btn>
          <v-btn
            color="success"
            large
            outline
            :loading="isSaleProcessing"
            :disabled="isSaleProcessing"
            @click="proceedPayment()"
          >Proceed</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
// import invoice from "./invoice";
import { productService } from "../../services/product-service";
import { taxService } from "../../services/tax-service";
import { categoryService } from "../../services/category-service";
import { customerService } from "../../services/customer-service";
import { Tax } from "../../models/model";
import { Sale } from "../../models/model";
import { saleService } from "../../services/sale-service";
import { SaleFormRules } from "../../helpers/validation-rules";
import { creditLevelService } from "../../services/credit-level-service";
import { discountService } from "../../services/discount-service";
import { userService } from "../../services/user-service";
import { commonService } from "../../services/common-service";
import { currencyService } from "../../services/currency-service";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "StockList",
  components: {
    Loading,
  },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    rules: new SaleFormRules(),
    valid: true,
    responseError: "",
    discountError: "",
    isShowStock: false,
    pageTitle: "Sale",
    showListLoading: false,
    showCustomerListLoading: false,
    ignorePagingWatch: true,
    isBreadcrumbs: false,
    breadcrumbs: [
      {
        text: "Sale",
        disabled: true,
      },
    ],
    rowsPerPageItems: [8, 16, 24, 48],
    pagination: {
      page: 1,
      rowsPerPage: 8,
      sortBy: "createdDate",
      totalItems: 0,
    },
    stockList: [],
    categoryName: "",
    productGroupName: "",
    productList: [],
    categoryList: [],
    counterList: [],
    totalRows: 0,
    customerTotalRows: 0,
    parkItems: [],
    showParkSales: false,
    showNote: false,
    showPaymentMethodDialog: false,
    modalValid: true,
    scanBarcode: "",
    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    queryParams: {
      status: "ACTIVE",
      categoryId: "",
      warehouseId: "",
      isSaleUnit: true,
      currencyId: "",
    },
    customerQueryParams: {
      name: "",
      email: "",
      creditLevelId: "",
    },
    customerRowsPerPageItems: [25, 50, 100],
    customerPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    autoCompleteParams: {
      code: "",
    },
    salePersonList: [],
    salePerson: "",
    discountPercentage: 0,
    discountAmount: 0,
    cardNo: "",
    tax: new Tax(),
    tableInfos: [],
    sale: new Sale(),
    netAmount: 0,
    isShowCurrency: true,
    currency: "",
    payTypes: ["CASH", "CREDIT"],
    categoryPanel: false,
    selectedPaymentMethod: 1,
    confirmBox: false,
    productCode: "",
    productName: "",
    productColor: "",
    productUnitList: [],
    openProductUnitDialog: false,
    payType: "CASH",
    isTaxOn: false,
    messageDialogBox: false,
    receivedAmount: 0,
    productCodeList: [],
    enteredProductCode: "",
    enteredProductGroupCode: "",
    customerList: [],
    isFOC: false,
    saleItems: [],
    focItems: [],
    currencyId: "",
    isFOCItemsExist: false,
    isSaleItemsExist: false,
    isLoading: false,
    fullPage: true,
    showCustomerListDialog: false,
    creditLevelList: [],
    currencyList: [],
    isSaleProcessing: false,
    productUnitId: "",
    factorUnitName: "",
    statusList: [
      { label: "PENDING", value: "PENDING" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" }
    ],
    status: "PENDING",
    issueDate: ""
  }),
  computed: {
    payChangeAmount() {
      return (this.payType === "CASH") ? (this.receivedAmount - this.netAmount) : 0;
    },
    getFOCItems() {
      return this.sale.saleItems.filter((item) => item.isFOC === true);
    },
    getSaleItems() {
      return this.sale.saleItems.filter((item) => item.isFOC !== true);
    },
  },
  watch: {
    pagination: {
      handler() {
        if (!this.ignorePagingWatch) {
          this.getProductList();
        }
      },
      deep: true,
    },
    customerPagination: {
      handler() {
        this.getCustomerList();
      },
      deep: true,
    },
    sale: {
      handler() {
        this.calculateAmount();
      },
      deep: true,
    },
  },
  created() {
    this.getActiveCurrency();
    this.init();
  },
  mounted() {
    this.$emit("drawer", false);
  },
  destroyed() {
    this.$emit("drawer", null);
  },
  methods: {
    changeCurrencyCode(){
    let cu = commonService.search("id",this.currencyId,this.currencyList);
    this.currency = cu.code;
    },
    getProductByCode(enteredProductCode) {
      this.queryParams.pro;
      productService
        .getProductByCode(enteredProductCode, this.queryParams.isSaleUnit, this.currencyId)
        .then((res) => {
          if (res.data) {
            this.showProductUnitDialog(res.data);
          } else {
            this.responseError = "Invalid Product Code !";
            this.messageDialogBox = true;
          }
          this.enteredProductCode = "";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeUnitPrice(item) {
      for (var i = 0; i < item.productUnits.length; ) {
        if (item.qty >= item.productUnits[i].factor) {
          let productunitprice = commonService.search("currencyId", this.currencyId, item.productUnits[i].productUnitPriceList);
                item.unitPrice =
                  productunitprice.sellingPrice /
                  item.productUnits[i].factor;
          break;
        } else {
          i++;
        }
      }
    },
    getProductGroupByCode(enteredProductGroupCode) {
      if (enteredProductGroupCode) {
        this.queryParams.productGroupCode = enteredProductGroupCode;
        this.queryParams.categoryId = "";
        this.queryParams.productGroupStatus = "ACTIVE";
      }
      this.pagination.page = 1;
      this.pagination.rowsPerPage = 8;
      this.$router.replace({
        name: "sales",
        query: this.queryParams,
      });
      this.productList = [];
      this.getProductList();
      if (this.productList.length === 0) {
        this.productGroupName = "";
        this.totalRows = 0;
      }
      this.enteredProductGroupCode = "";
    },
    getAllCustomer() {
      customerService
        .getAllCustomers()
        .then((res) => {
          if (res.data) {
            this.customerList = res.data.customerList;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    confirmPayment() {
      if (!this.$refs.paymentModalForm.validate()) {
        return;
      }
      if (
        this.discountAmount > 0 &&
        this.sale.discountAmount > this.discountAmount
      ) {
        this.sale.discountAmount = 0;
        this.discountError =
          "*Discount amount must not be greater than " +
          Math.floor(this.discountAmount*100)/100 +
          this.currency;
      } else {
        this.showPaymentMethodDialog = false;
        this.confirmBox = true;
        this.discountError = "";
      }
    },
    proceedPayment() {
      if (!this.isSaleProcessing) {
        this.isSaleProcessing = true;
        this.save();
        this.showPaymentMethodDialog = false;
        this.confirmBox = false;
      }
    },
    cancelPayment() {
      this.showPaymentMethods();
    },
    trigger(barcode) {
      this.scanBarcode = "";
      if (barcode) {
        this.getProductUnitByBarcode(barcode);
      }
    },
    onSearch(category) {
      if (category) {
        this.queryParams.categoryId = category.id;
        this.queryParams.productGroupCode = "";
        this.categoryName = category.name;
      }
      this.queryParams.currencyId = this.currencyId;
      this.pagination.page = 1;
      this.pagination.rowsPerPage = 8;
      this.$router.replace({ name: "sales", query: this.queryParams });
      this.getProductList();
    },
    customerOnSearch() {
      this.customerQueryParams.page = this.customerPagination.page;
      this.customerQueryParams.size = this.customerPagination.rowsPerPage;
      this.getCustomerList();
    },
    getCustomerList() {
      this.showCustomerListLoading = true;
      let order = this.customerPagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.customerQueryParams,
          this.customerPagination.page,
          this.customerPagination.rowsPerPage,
          this.customerPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.customerList = res.data.customerList;
            this.customerTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showCustomerListLoading = false;
        });
    },
    showCustomers() {
      // Clean query params
      this.customerQueryParams.name = "";
      this.customerQueryParams.email = "";
      this.customerQueryParams.creditLevelId = "";

      this.getCustomerList().then(
        (this.showCustomerListDialog = !this.showCustomerListDialog)
      );
    },
    getTax() {
      return taxService
        .getTaxByStatus("ACTIVE")
        .then((res) => {
          if (res.data) {
            this.tax = res.data;
            this.sale.taxId = this.tax.id;
            this.sale.taxName = this.tax.name;
            this.sale.taxType = this.tax.taxType;
            this.sale.taxPercentage = this.tax.percentage;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy ? this.pagination.sortBy + "," + order : ""
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            if (this.productList[0].productGroupName) {
              this.productGroupName = this.productList[0].productGroupName;
            }
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getCategoriesByStatus() {
      return categoryService
        .getCategoriesByStatus("ACTIVE")
        .then((res) => {
          this.categoryList = res.data;
          if (!this.queryParams.categoryId) {
            this.queryParams.categoryId = this.categoryList[0].id;
            this.categoryName = this.categoryList[0].name;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addToCart(productUnit) {
      this.productCode = productUnit.product.code;
      let currencyId = this.currencyId;
      if (this.isItemExist(productUnit.product, this.isFOC)) {
        let isFOCFlag = this.isFOC;
        this.sale.saleItems.forEach(function (item) {
          if (
            item.productId === productUnit.product.id &&
            item.isFOC === isFOCFlag
          ) {
            item.qty = Math.abs(item.qty) + Math.abs(productUnit.factor);
            //unit price
            for (var i = 0; i < item.productUnits.length; ) {
              if (item.qty >= item.productUnits[i].factor) {
               let productunitprice = commonService.search("currencyId", currencyId, item.productUnits[i].productUnitPriceList);
                item.unitPrice =
                  productunitprice.sellingPrice /
                  item.productUnits[i].factor;
                break;
              } else {
                i++;
              }
            }
          }
        });
      } else {
        let item = {
          productUnitId: 0,
          productId: 0,
          qty: 0,
          unitPrice: 0,
          barcode: "",
          totalPrice: 0,
          factorUnitName: "",
          productName: "",
          productColor: "",
          isFOC: false,
          productUnits: [],
        };

        item.productId = productUnit.product.id;
        item.productCode = productUnit.product.code;
        item.barcode = productUnit.barcode;
        item.productName = productUnit.product.name;
        item.productColor = productUnit.product.color;
        item.productUnitId = productUnit.id;
        item.factorUnitName = productUnit.factor + "/" + productUnit.unitName;
        item.qty = productUnit.factor;
        item.unitPrice = productUnit.sellingPrice / productUnit.factor;
        console.log(productUnit.sellingPrice);
        console.log(item.unitPrice);
        if (this.isFOC) {
          item.isFOC = this.isFOC;
        }
        this.sale.saleItems.push(item);
        productService
          .getProductDetail(productUnit.product.id)
          .then((res) => {
            item.productUnits = res.data.productUnits;
            item.productUnits.sort((a, b) => {
              if (a.factor > b.factor) {
                if (a.basicUnit == true) {
                  item.productUnitId = a.id;
                  item.factorUnitName = a.factor + "/" + a.unitName;
                }
                if (b.basicUnit == true) {
                  item.productUnitId = b.id;
                  item.factorUnitName = b.factor + "/" + b.unitName;
                }
                return -1;
              }
              return 0;
            });

            for (var i = 0; i < item.productUnits.length; i++) {
              if (item.qty >= item.productUnits[i].factor) {
                let productunitprice = commonService.search("currencyId", this.currencyId, item.productUnits[i].productUnitPriceList);
                item.unitPrice =
                  productunitprice.sellingPrice /
                  item.productUnits[i].factor;
                break;
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    calculateAmount() {
      let total = 0;
      this.sale.saleItems.forEach((item) => {
        if (!item.isFOC) {
          item.totalPrice = item.qty * item.unitPrice;
          total += item.totalPrice;
        }
      });
      this.sale.totalAmount = parseFloat(total).toFixed(2);
      let commercialTax = 0;
      if (this.sale.taxPercentage > 0) {
        commercialTax = total * (this.sale.taxPercentage / 100);
      }
      if (!this.isTaxOn) {
        commercialTax = 0;
      }
      let taxType = this.sale.taxType;
      if (taxType === "ADD_ON") {
        this.netAmount = total + commercialTax;
      } else {
        this.netAmount = total - commercialTax;
      }
      this.sale.taxAmount = commercialTax;
      this.netAmount = parseFloat(this.netAmount - this.sale.discountAmount).toFixed(2);
      if (this.sale.id) {
        this.receivedAmount = this.sale.receivedAmount;
      } else if (this.payType === "CASH") {
        this.receivedAmount = this.netAmount;
      } else {
        this.receivedAmount = 0;
      }
    },
    save() {
      this.sale.payChange = parseFloat(this.payChangeAmount).toFixed(2);
      this.sale.netAmount = parseFloat(this.netAmount).toFixed(2);
      this.sale.payType = this.payType;
      this.sale.receivedAmount = parseFloat(this.receivedAmount).toFixed(2);
      this.sale.shiftAssignDetailId = this.user.shiftAssignDetailId;
      this.sale.currencyId = this.currencyId;
      saleService
        .saveSale(this.sale)
        .then((res) => {
          this.sale.saleNo = res.data.sale.saleNo;
          this.sale.saleId = res.data.sale.id;
        })
        .then(() => {
          if (this.sale.payType == "CASH") {
            this.printInvoice("invoicePrint");
          } else {
            this.isLoading = true;
            this.printInvoiceById(this.sale.saleId);
          }
        })
        .then(() => {
          if (this.sale.id) this.goBack();
        })
        .catch(err => {
          this.isLoading = false;
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
            this.messageDialogBox = true;
            this.isSaleProcessing = false;
          }
        });
    },
    printInvoiceById(id) {
      saleService
        .printSaleInvoiceById(id)
        .then((res) => {
          var blob = res;
          saleService.showWindowDialog(blob, "SaleInvoice-" + id);
        })
        .then(() => {
          if (this.sale.id) {
            this.goBack();
          } else {
            this.init();
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    printInvoice(divName) {
      var d = new Date();
      var t = d.toLocaleTimeString();
      var mydate = new Date().toString("MMMM yyyy");
      document.getElementById("date").innerHTML = mydate.substr(0, 16) + t;
      var printContents = document.getElementById(divName).innerHTML;

      // var originalContents = document.body.innerHTML;
      var myWindow = window.open("", "MsgWindow", "width=350,height=500");
      myWindow.document.write(printContents);

      // document.body.innerHTML = printContents;
      myWindow.print();

      // document.body.innerHTML = originalContents;
      myWindow.close();

      // if (this.sale.id) {
      //   this.goBack();
      // }
      // clear previous cart item
      if (this.sale.id) {
        this.goBack();
      } else {
        this.init();
      }
    },
    printOrderNote(divName) {
      var d = new Date();
      var t = d.toLocaleTimeString();
      var mydate = new Date().toString("MMMM yyyy");
      document.getElementById("orderNoteDate").innerHTML =
        mydate.substr(0, 16) + t;
      var printContents = document.getElementById(divName).innerHTML;
      var originalContents = document.body.innerHTML;
      document.body.innerHTML = "";
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
    },
    init() {
      const id = this.$route.params.id;
      if (id == "new") {
        // new sale
        this.issueDate = commonService.formatDate(
          new Date().toISOString().substr(0, 10),
          "YYYY-MM-DD"
        );
      } else {
        this.getSaleDetail(id);
      }
      if (this.sale) {
        this.sale = new Sale();
      }
      this.isSaleProcessing = false;
      this.getCreditLevels();
      this.getTax();
      this.getAllCustomer();
      this.getCategoriesByStatus()
        .then(this.getProductList)
        .then(() => {
          this.ignorePagingWatch = false;
        });
      let user = JSON.parse(localStorage.getItem("user"));
      this.sale.shopId = user.shop.id;
      this.sale.counterId = user.counterId;
      this.sale.shiftAssignDetailId = user.shiftAssignDetailId;
      this.sale.shopName = user.shop.name;
      this.sale.phoneNo = user.shop.phoneNo;
      this.sale.address = user.shop.address;
      this.sale.username = user.username;
      this.sale.counterName = user.counterName;
      this.getSalePersonList();
      this.salePerson = "";
      this.isFOCFlag = false;
      // check park items
      var parkItemsLocalStorage = JSON.parse(localStorage.getItem("parkItems"));
      if (parkItemsLocalStorage) {
        this.parkItems = parkItemsLocalStorage;
      }

      //for deep linking
      if (this.$route.query.status) {
        this.queryParams.status = this.$route.query.status;
      }
      if (this.$route.query.categoryId) {
        this.queryParams.categoryId = this.$route.query.categoryId;
      }
      if (this.$route.query.barcode) {
        this.queryParams.barcode = this.$route.query.barcode;
      }
      if (this.$route.query.page) {
        this.pagination.page = this.$route.query.page;
      }
      if (this.$route.query.size) {
        this.pagination.size = this.$route.query.size;
      }
      if (this.$route.query.categoryId) {
        this.queryParams.categoryId = this.$route.query.categoryId;
      }
      if (this.$route.query.warehouseId) {
        this.queryParams.warehouseId = this.$route.query.warehouseId;
      } else {
        this.queryParams.warehouseId = user.shop.warehouse.id;
      }
    },
    showProductUnitDialog(product) {
      this.productUnitId = "";
      this.openProductUnitDialog = true;
      this.productUnitList = product.productUnits;
      if (this.productUnitList.length == 1) {
        this.productUnitId = product.productUnits[0].id;
      } else {
        this.productUnitList.sort((a, b) => {
          if (a.factor < b.factor) {
            if (a.basicUnit == true) {
              this.productUnitId = a.id;
              this.factorUnitName = a.factor + "/" + a.unitName;
            }
            if (b.basicUnit == true) {
              this.productUnitId = b.id;
              this.factorUnitName = b.factor + "/" + b.unitName;
            }
            return -1;
          }
          return 0;
        });
      }
      this.productCode = product.code;
      this.productName = product.name;
      this.productColor = product.color;
    },
    removeItem(index, saleId) {
      if (saleId) {
        // add delete stock in id
        if (!this.sale.deleteSaleDetailIds) {
          this.sale.deleteSaleDetailIds = [];
        }
        this.sale.deleteSaleDetailIds.push(saleId);
      }
      this.$delete(this.sale.saleItems, index);
    },
    parkSale() {
      if (!this.$refs.noteDialog.validate()) {
        return;
      }
      this.showNote = false;

      var parkItemsLocalStorage = JSON.parse(localStorage.getItem("parkItems"));
      if (!parkItemsLocalStorage) {
        parkItemsLocalStorage = [];
      }
      parkItemsLocalStorage.push(this.sale);
      this.parkItems = parkItemsLocalStorage;
      localStorage.setItem("parkItems", JSON.stringify(parkItemsLocalStorage));
      if (this.sale.id) {
        this.goBack();
      } else {
        this.init();
      }
    },
    retrieveSale(index) {
      var parkItemsLocalStorage = JSON.parse(localStorage.getItem("parkItems"));
      this.sale = parkItemsLocalStorage[index];
      this.$delete(parkItemsLocalStorage, index);
      this.parkItems = parkItemsLocalStorage;
      localStorage.setItem("parkItems", JSON.stringify(parkItemsLocalStorage));
      this.showParkSales = false;
    },
    closeModal() {
      this.$refs.noteDialog.resetValidation();
      this.showNote = false;
    },
    showPaymentMethods() {
      if (this.$refs.form.validate()) {
        this.showPaymentMethodDialog = true;
        this.confirmBox = false;
        discountService.getDiscountByStatusAndDiscountType("ACTIVE","RETAIL_SALE").then((res) => {
          if (res.data) {
            let discount = res.data[0];
            if (discount) {
              this.discountAmount =
                discount.percentage * 0.01 * this.sale.totalAmount;
            }
          }
        });
      }
    },
    isItemExist(product, isFOC) {
      for (let item of this.sale.saleItems) {
        if (item.productId === product.id && item.isFOC === isFOC) {
          return true;
        }
      }
    },
    getProductUnitByBarcode(barcode) {
      productService
        .getProductUnitByBarcode(barcode, this.currencyId)
        .then((res) => {
          let productUnit = res.data;
          if (productUnit) {
            if (productUnit.qty > 0) {
              if (productUnit.reorderQty == 0 || ((productUnit.qty * productUnit.factor) > productUnit.reorderQty && productUnit.reorderQty > 0)) {
                this.addToCart(productUnit);
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onClose() {
      this.showPaymentMethodDialog = false;
      this.discountError = "";
    },
    getCreditLevels() {
      creditLevelService
        .getCreditLevels()
        .then((res) => {
          if (res.data) {
            this.creditLevelList = res.data.creditLevelList;
            let findAll = {
              id: "",
              name: "----All----",
            };
            this.creditLevelList.splice(
              0,
              0,
              JSON.parse(JSON.stringify(findAll))
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setCustomer(customer) {
      this.sale.customerId = customer.id;
      this.sale.customerName = customer.name;
      this.showCustomerListDialog = !this.showCustomerListDialog;
    },
    getSalePersonList() {
      userService
        .getAllSalePerson()
        .then((res) => {
          res.data.forEach((item) => {
            if (this.sale.shopId == item.shopId) {
              this.salePersonList.push(item);
            }
          });
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.responseError.data.message;
          }
        });
    },
    getSalePersonName(id) {
      this.salePersonList.forEach((item) => {
        if (item.id == id) {
          this.salePerson = item.username;
        }
      });
    },
    getCustomerRule() {
      if (this.payType == "CASH") return [];
      else return this.rules.customerIdRules;
    },
    getSaleDetail(id) {
      saleService.getSaleDetail(id).then(res => {
        this.sale = res.data;
          if (this.sale.taxAmount > 0) {
        if (this.sale) {
            this.isTaxOn = true;
          }
        }
        this.status = this.sale.status;
        this.sale.username = this.user.username;
        this.netAmount = this.sale.netAmount;
        this.payType = this.sale.payType;
        this.receivedAmount = this.sale.receivedAmount;
        // deep copy
        this.oldSale = JSON.parse(JSON.stringify(res.data));
      });
    },
    getActiveCurrency(){
    currencyService.getCurrencyByStatus('ACTIVE')
    .then(res => {
      if(res.data){
        this.currencyList = res.data;
        let c = commonService.search("defaultCurrency",true,this.currencyList);
        if(c){
          this.currencyId = c.id;
          this.currency = c.code;
          this.onSearch();
        }
      }
    })
    .catch((err) => {
          if (err.response.data) {
            this.responseError = err.responseError.data.message;
          }
        });
    },
    goBack() {
      this.$router.push("/saleperson-sales");
    }
  }
};
</script>

<style scoped>
.stock-name {
  width: 110px;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.cart {
  font-size: 12px;
}
</style>
